
URL = globalThis.URL
import __vite__wasmUrl from "/vercel/path0/src/modules/ttml-processor/wasm/ttml_processor_wasm_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./ttml_processor_wasm_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./ttml_processor_wasm_bg.js": { "__wbg_new_bebc3f4757acf305": __vite__wasmImport_0["__wbg_new_bebc3f4757acf305"],
"__wbg_set_6be42768c690e380": __vite__wasmImport_0["__wbg_set_6be42768c690e380"],
"__wbg_set_bf6dde4923b9b059": __vite__wasmImport_0["__wbg_set_bf6dde4923b9b059"],
"__wbg_new_ffa92086ea89f79c": __vite__wasmImport_0["__wbg_new_ffa92086ea89f79c"],
"__wbg_set_13d25b81ab403f5e": __vite__wasmImport_0["__wbg_set_13d25b81ab403f5e"],
"__wbg_get_with_ref_key_6412cf3094599694": __vite__wasmImport_0["__wbg_get_with_ref_key_6412cf3094599694"],
"__wbg_length_4e1adc0d42e23620": __vite__wasmImport_0["__wbg_length_4e1adc0d42e23620"],
"__wbindgen_object_drop_ref": __vite__wasmImport_0["__wbindgen_object_drop_ref"],
"__wbg_isSafeInteger_8f51c743827d1ec5": __vite__wasmImport_0["__wbg_isSafeInteger_8f51c743827d1ec5"],
"__wbg_Number_c54e7112a3fa7e3e": __vite__wasmImport_0["__wbg_Number_c54e7112a3fa7e3e"],
"__wbg_Error_67e7344beaa85059": __vite__wasmImport_0["__wbg_Error_67e7344beaa85059"],
"__wbg_get_b1f0ab13c737f856": __vite__wasmImport_0["__wbg_get_b1f0ab13c737f856"],
"__wbg_isArray_5674713bb7b79043": __vite__wasmImport_0["__wbg_isArray_5674713bb7b79043"],
"__wbg_next_f31ecb8646d2c605": __vite__wasmImport_0["__wbg_next_f31ecb8646d2c605"],
"__wbg_done_cffed884d87aa22e": __vite__wasmImport_0["__wbg_done_cffed884d87aa22e"],
"__wbg_value_c227f843d21da141": __vite__wasmImport_0["__wbg_value_c227f843d21da141"],
"__wbg_get_unchecked_363572bdd397d473": __vite__wasmImport_0["__wbg_get_unchecked_363572bdd397d473"],
"__wbg_new_227d7c05414eb861": __vite__wasmImport_0["__wbg_new_227d7c05414eb861"],
"__wbg_stack_3b0d974bbf31e44f": __vite__wasmImport_0["__wbg_stack_3b0d974bbf31e44f"],
"__wbg_error_757e9472f8410341": __vite__wasmImport_0["__wbg_error_757e9472f8410341"],
"__wbg_iterator_22ddeb808cf55a6f": __vite__wasmImport_0["__wbg_iterator_22ddeb808cf55a6f"],
"__wbg_get_6cf5a4d4d8ad3c5a": __vite__wasmImport_0["__wbg_get_6cf5a4d4d8ad3c5a"],
"__wbg_call_269c5566fbede3eb": __vite__wasmImport_0["__wbg_call_269c5566fbede3eb"],
"__wbg_next_95053e306b1c3aed": __vite__wasmImport_0["__wbg_next_95053e306b1c3aed"],
"__wbg_length_31bdaf014f5fbde2": __vite__wasmImport_0["__wbg_length_31bdaf014f5fbde2"],
"__wbg_prototypesetcall_ae9f5e7459250748": __vite__wasmImport_0["__wbg_prototypesetcall_ae9f5e7459250748"],
"__wbg_parse_6937a9050adfb0e1": __vite__wasmImport_0["__wbg_parse_6937a9050adfb0e1"],
"__wbg___wbindgen_number_get_1dc732b810cb937c": __vite__wasmImport_0["__wbg___wbindgen_number_get_1dc732b810cb937c"],
"__wbg_instanceof_Uint8Array_598adc0fef426aa8": __vite__wasmImport_0["__wbg_instanceof_Uint8Array_598adc0fef426aa8"],
"__wbg_instanceof_ArrayBuffer_d4ff01f8247925ae": __vite__wasmImport_0["__wbg_instanceof_ArrayBuffer_d4ff01f8247925ae"],
"__wbg_new_1da3429bc3c4541c": __vite__wasmImport_0["__wbg_new_1da3429bc3c4541c"],
"__wbg___wbindgen_jsval_loose_eq_3c30021c243b64cd": __vite__wasmImport_0["__wbg___wbindgen_jsval_loose_eq_3c30021c243b64cd"],
"__wbindgen_object_clone_ref": __vite__wasmImport_0["__wbindgen_object_clone_ref"],
"__wbg_entries_972a87586902cf87": __vite__wasmImport_0["__wbg_entries_972a87586902cf87"],
"__wbg_String_8564e559799eccda": __vite__wasmImport_0["__wbg_String_8564e559799eccda"],
"__wbg_new_8d36e20aa758e411": __vite__wasmImport_0["__wbg_new_8d36e20aa758e411"],
"__wbg___wbindgen_throw_5d9e815e6fdf150f": __vite__wasmImport_0["__wbg___wbindgen_throw_5d9e815e6fdf150f"],
"__wbg___wbindgen_string_get_92ab86bb19cbc12f": __vite__wasmImport_0["__wbg___wbindgen_string_get_92ab86bb19cbc12f"],
"__wbg___wbindgen_in_50072d4d6e45c193": __vite__wasmImport_0["__wbg___wbindgen_in_50072d4d6e45c193"],
"__wbg___wbindgen_is_null_5160b3e381865372": __vite__wasmImport_0["__wbg___wbindgen_is_null_5160b3e381865372"],
"__wbg___wbindgen_is_object_edb6b15aa3afe12e": __vite__wasmImport_0["__wbg___wbindgen_is_object_edb6b15aa3afe12e"],
"__wbg___wbindgen_is_string_c4f7cb494a2a21f1": __vite__wasmImport_0["__wbg___wbindgen_is_string_c4f7cb494a2a21f1"],
"__wbg___wbindgen_boolean_get_7a12af2b3f899c5a": __vite__wasmImport_0["__wbg___wbindgen_boolean_get_7a12af2b3f899c5a"],
"__wbg___wbindgen_is_function_fcda5e3902d732fe": __vite__wasmImport_0["__wbg___wbindgen_is_function_fcda5e3902d732fe"],
"__wbg___wbindgen_is_undefined_8c687d0b90d5b524": __vite__wasmImport_0["__wbg___wbindgen_is_undefined_8c687d0b90d5b524"],
"__wbg___wbindgen_debug_string_0e68cf47c9cbd9b0": __vite__wasmImport_0["__wbg___wbindgen_debug_string_0e68cf47c9cbd9b0"],
"__wbindgen_generic_0000000000000001": __vite__wasmImport_0["__wbindgen_generic_0000000000000001"],
"__wbindgen_generic_0000000000000002": __vite__wasmImport_0["__wbindgen_generic_0000000000000002"],
"__wbindgen_generic_0000000000000003": __vite__wasmImport_0["__wbindgen_generic_0000000000000003"] } }, __vite__wasmUrl);
export const {
  memory,
  amllToTtml,
  amllToTtmlResult,
  generateTtml,
  main_js,
  parseTtml,
  ttmlResultToAmll,
  ttmlToAmll,
  __abort_handler,
  __instance_terminated,
  __wbindgen_export,
  __wbindgen_export2,
  __wbindgen_export3,
  __wbindgen_export4,
  __wbindgen_start,
} = __vite__wasmModule;
